import { VisionButtonComponent } from '@core-mkt/shared/components/vision-button/vision-button/vision-button.component';
import { Component, Input } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import type { Image } from '@core-mkt/interfaces/image';
import { BrandConfigurationService } from '@core-mkt/services/configuration/brand-configuration.service';
import { EnvService } from '@core-mkt/services/env/env.service';
import { ImgixService } from '@core-mkt/services/imgix/imgix.service';
import { getParsedLinkString, getQueryParamString } from '@core-mkt/services/query-param/query-helpers';
import { QueryParamService } from '@core-mkt/services/query-param/query-param.service';
import { WysiwygRedactorService } from '@core-mkt/services/wysiwg-redactor/wysiwyg-redactor.service';
import type { VisionButton } from '../../vision-button/vision-button/vision-button';
import { CareerCenterArticleCard } from '../career-center/career-center';

@Component({
  selector: 'career-center-article-card',
  templateUrl: './career-center-article-card.component.html',
  styleUrls: ['./career-center-article-card.component.scss'],
  standalone: true,
  imports: [VisionButtonComponent, LazyImgDirective],
})
export class CareerCenterArticleCardComponent {
  @Input() data: CareerCenterArticleCard;
  resourceTextContent = undefined;

  constructor(
    private redactor: WysiwygRedactorService,
    private imgixService: ImgixService,
    private queryParamService: QueryParamService,
    private brand: BrandConfigurationService,
    private env: EnvService,
  ) {}

  get image(): Image | undefined {
    return this.data.image?.[0];
  }

  get relatedResourceContent(): string | undefined {
    return this.data.relatedResourceContent;
  }

  get relatedResourcesCategory(): string | undefined {
    const relatedResourcesCategory = this.data.relatedResourcesCategory;
    const careerCenterArticleCards = this.data.careerCenterArticleCards;

    if (relatedResourcesCategory?.length === 0 || careerCenterArticleCards?.length === 0) {
      return '';
    } else if (relatedResourcesCategory?.length > 0) {
      return relatedResourcesCategory[0]?.title;
    } else if (careerCenterArticleCards?.length > 0) {
      return careerCenterArticleCards[0]?.title;
    }
  }

  get relatedResourceLink(): string | undefined {
    return this.data.relatedResourceLink;
  }

  get relatedResourceCtaLabel(): string | undefined {
    return this.data.relatedResourceCtaLabel;
  }

  get ctaButtonData(): VisionButton {
    return {
      buttonStyle: 'tertiary',
      bgTheme: 'bg-white',
      buttonText: this.relatedResourceCtaLabel || 'Read Full Article',
      buttonLink: this.relatedResourceLink,
      fullWidth: false,
      nofollow: false,
      noreferrer: false,
      noopener: false,
      newTab: false,
      useIcon: true,
    };
  }

  getTargetUrl(): string | undefined {
    const link = this.relatedResourceLink;
    if (!link) {
      return undefined;
    }
    const queryParams = this.queryParamService.getQueryParams();
    const blogPrefix = this.env.get.blogPrefix;
    const queryString = getQueryParamString(queryParams, link, blogPrefix);
    return getParsedLinkString(link, queryString, this.brand.hostName, this.brand.siblingSites, blogPrefix);
  }

  articleRoute(): void {
    const target = this.getTargetUrl();
    if (target) {
      window.location.href = target;
    }
  }
}
